import {isNil} from 'ramda';

import {BrowserPhoneFailure} from '../types/BrowserPhoneFailure';

const BLOCKED_ERROR_NAMES = ['NotAllowedError', 'SecurityError'];

/**
 * Asks for the microphone before a browser call is created, so a denied prompt or a missing
 * microphone stops the call before the backend records it. Resolves null when access is granted;
 * the stream is released at once, the Voice SDK opens its own.
 */
export const requestMicrophoneAccess = (): Promise<Exclude<
  BrowserPhoneFailure,
  'CONNECTION_FAILED'
> | null> => {
  if (isNil(navigator.mediaDevices?.getUserMedia)) {
    return Promise.resolve('NO_MICROPHONE' as const);
  }

  return navigator.mediaDevices
    .getUserMedia({audio: true})
    .then((stream) => {
      stream.getTracks().forEach((track) => track.stop());
      return null;
    })
    .catch((error: unknown) =>
      error instanceof DOMException && BLOCKED_ERROR_NAMES.includes(error.name)
        ? ('MICROPHONE_BLOCKED' as const)
        : ('NO_MICROPHONE' as const)
    );
};
